import React from 'react';
import TestRunner from '../testing/TestRunner';

const TestingTools: React.FC = () => {
  return (
    <div>
      <TestRunner />
    </div>
  );
};

export default TestingTools;
